import { get as getBrowse } from "#skyward_browse";
import { getBrowseById } from "#skyward_browseList";
import { mobileAccess, virtualDir } from "#skyward_global";
import { ButtonDefinition, ButtonIcon, ButtonText, ModalDialog, showDialog } from "#skyward_modalLayer";
import { closePopup, registerLayoutResizeCallback, removeLayoutResizeCallback } from "#skyward_window";
import { disable, enable } from "./skyward.ui.controls";
import { displayValidationMessages } from "./skyward.ui.validation";
import { JQueryInput } from "./types";

const skyward = window.skyward;

export let initialize = function (html: JQueryInput, area: string, controller: string, data?: object, saveOrderOverride?: (dialog: ModalDialog) => void)
{
    let sortable: JQuery<HTMLElement>;
    let messageBox: ModalDialog;
    let originalIndex: number;
    let numberOfColumns: number;
    let announcementRegion: JQuery<HTMLElement>;

    const sortableOptions: JQueryUI.SortableOptions =
    {
        cancel: ".sortableDelete",
        cursor: "move",
        scroll: true,
        start: function (_e, ui)
        {
            originalIndex = ui.item.index() + 1;
        },
        update: function (_e, ui)
        {
            sortableUpdate(ui ? ui.item : null);
        },
        items: ".sortableRow",
        sort: function (_e, _ui)
        {
            handleSortablePlaceholder();
        },
        containment: "parent",
        tolerance: "pointer",
        axis: "y"
    };

    const sortableArea: string = area;
    const sortableController: string = controller;

    showMessageBox();

    sortable = messageBox!.content.find(".sortable").first();
    const sortableBody = messageBox!.content.find("tbody");

    modifyBody(sortableBody);
    addAccessibilityLabels(sortableBody);
    setupAnnouncement();

    if (!mobileAccess)
    {
        sortableBody.sortable(sortableOptions);
    }

    sortableBody.disableSelection();

    sortable.addClass("sortable__modal");

    resizePanel();

    numberOfColumns = $("tr.sortableHeaderRow th").length;

    sortable.on("click", ".sortableDelete", function()
    {
        const button = $(this);

        button.closest("tr").first().remove();
        originalIndex = sortable.find(".sortableDelete").length + 1;
        sortableUpdate();
    });

    sortable.on("click", ".js-sortableUp", function ()
    {
        const button = $(this);
        const row = button.closest(".sortableRow");

        originalIndex = row.index() + 1;
        row.insertBefore(row.prev());

        button.trigger("focus");
        sortableUpdate(row);
    });

    sortable.on("click", ".js-sortableDown", function ()
    {
        const button = $(this);
        const row = button.closest(".sortableRow");

        originalIndex = row.index() + 1;
        row.insertAfter(row.next());

        button.trigger("focus");
        sortableUpdate(row);
    });

    registerLayoutResizeCallback(resizePanel);

    function setupAnnouncement()
    {
        announcementRegion = $("<div>",
            {
                class: "sr-only",
                "aria-live": "assertive"
            });

        messageBox!.content.append(announcementRegion);
    }

    function updateAnnouncement(updatedRow?: JQuery<HTMLElement> | null)
    {
        if (!updatedRow)
        {
            return;
        }

        const dataCells = updatedRow.find(".browseDataCell");

        if (dataCells.length < 2)
        {
            return;
        }

        const title = dataCells[1].textContent;

        const header = messageBox!.content.find(".sortableHeaderRow");
        const headerCells = header.find("th");
        if (headerCells.length < 3)
        {
            return;
        }

        const positionColumnName = headerCells[1].textContent ?? "Position";

        announcementRegion.text(`${title} moved to ${positionColumnName} ${updatedRow.index() + 1}`);
    }

    function resizePanel()
    {
        const topMostLayer = $("div.modalLayerContainer").last();
        if (topMostLayer.length <= 0)   //If sortable panel is closed, remove the callback event
        {
            removeLayoutResizeCallback(resizePanel);
        }
    }

    function sortableUpdate(updatedRow?: JQuery | null)
    {
        updateSortNumber(updatedRow);
        handleSortablePlaceholder();
        toggleSortableButtons();
        updateAnnouncement(updatedRow);
    }

    function updateSortNumber(updatedRow: JQuery | null | undefined)
    {
        const dropIndex = updatedRow ? (updatedRow.index()) : 0;
        const start = Math.min(dropIndex, originalIndex - 1);
        const end = Math.max(dropIndex, originalIndex - 1) + 1;

        sortable.find("td.sortColumn div").slice(start, end).each(function (index, element)
        {
            $(element).html(String(start + index + 1));
        });
    }

    function handleSortablePlaceholder()
    {
        $(".sortableRow.ui-sortable-placeholder").not(".ui-sortable-helper").each(function (_index, value)
        {
            const element = $(value);
            element.html(`<td colspan='${numberOfColumns}'></td>`);
            element.css({ 'visibility': 'visible' });
        });
    }

    function getOrder()
    {
        const list: { id: number; }[] = [];

        sortable.find("tbody tr").each(function (index, element)
        {
            list[index] = { id: $(element).data("id") };
        });

        return JSON.stringify(list);
    }

    function saveOrder()
    {
        const saveAction = $("#saveAction");
        const container = $("#sortablecontentmessagearea");
        const postData = $.extend({}, data, { sortOrder: getOrder(), "SortableID_SecurityHash": saveAction.data("sortableid_securityhash"), warninghashes: JSON.stringify(container.data("warninghashes")) });
        return $.ajax(
            {
                url: `${virtualDir}${sortableArea}/${sortableController}/${saveAction.val()}`,
                type: "POST",
                data: postData,
                success: function (result)
                {
                    if (result.success)
                    {
                        messageBox.close();
                        refreshBrowse(saveAction.data("browsetorefreshaftersave"));
                    }
                    else
                    {
                        let baseErrorContainer = $(messageBox.modalLayer.contents).find("#CurrentRecordContentBaseError");
                        if (typeof baseErrorContainer == "undefined" || baseErrorContainer == null || baseErrorContainer.length < 1)
                        {
                            baseErrorContainer = $("#CurrentRecordContentBaseError");
                        }

                        displayValidationMessages(result, container, baseErrorContainer);
                    }
                }
            });
    }

    function refreshBrowse(browseToRefreshAfterSave?: string)
    {
        const detailsPanelName = `detailsPanel_${browseToRefreshAfterSave}`;
        let browseRefreshed = false;

        // If there's a browse with the same name in the Winkelpanel as one outside it,
        // we'll refresh both browses to ensure we get the right one. Refreshing both
        // shouldn't hurt anything.
        if (browseToRefreshAfterSave)
        {
            if (getBrowseById(browseToRefreshAfterSave))
            {
                getBrowse(browseToRefreshAfterSave);
                browseRefreshed = true;
            }

            if (getBrowseById(detailsPanelName))
            {
                getBrowse(detailsPanelName);
                browseRefreshed = true;
            }
        }

        if (!browseRefreshed)
        {
            window.location.reload();
        }
    }

    function customSaveOrder()
    {
        saveOrderOverride!(messageBox);
    }

    function showMessageBox()
    {
        const buttons: ButtonDefinition[] =
        [
            { text: ButtonText.Save, icon: ButtonIcon.Save, click: (saveOrderOverride ? customSaveOrder : saveOrder) },
            { text: ButtonText.Cancel, icon: ButtonIcon.Cancel, click: function () { messageBox.close(); } }
        ];

        closePopup();
        messageBox = showDialog($(html).find("#sortableTitle").val() as string, html, buttons, { closeOnClick: false, hideOverflow: true });

        messageBox.bodyPromise.then(toggleSortableButtons);
    }

    function toggleSortableButtons()
    {
        const allButtons = sortable.find(".js-sortableUp,.js-sortableDown");
        const upButtons = allButtons.filter(".js-sortableUp");
        const downButtons = allButtons.filter(".js-sortableDown");

        const firstUpButton = upButtons.first();
        const lastDownButton = downButtons.last();

        // We must store this prior to disabling.  IE causes disabled elements to lose focus.
        // TODO (someday) check if this is still needed
        const firstUpButtonHasFocus = firstUpButton.is(":focus");
        const lastDownButtonHasFocus = lastDownButton.is(":focus");

        disable(firstUpButton);
        disable(lastDownButton);

        enable(upButtons.not(firstUpButton));
        enable(downButtons.not(lastDownButton));

        const activeButtons = allButtons.not(firstUpButton).not(lastDownButton);

        if (firstUpButtonHasFocus)
        {
            activeButtons.first().trigger("focus");
        }
        else if (lastDownButtonHasFocus)
        {
            activeButtons.last().trigger("focus");
        }
    }
}

function modifyBody(body: JQuery<HTMLElement>)
{
    const table = body.closest("table");
    let head = table.find("thead");
    if (head.length === 0)
    {
        head = $("<thead>");
        table.prepend(head);
    }

    const sortableHeader = body.find(".sortableHeaderRow");
    if (sortableHeader.length > 0)
    {
        const dataCells = sortableHeader.find("td");
        dataCells.each(function (this: HTMLTableCellElement)
        {
            $(this).replaceTagNames("th");
        });
        head.append(sortableHeader);
    }
}

function addAccessibilityLabels(body: JQuery<HTMLElement>)
{
    const rows = body.find("tr");

    rows.each(function (this: HTMLTableRowElement)
    {
        const row = $(this);

        const dataCells = row.find(".browseDataCell");
        if (dataCells.length > 2)
        {
            const dataCell = dataCells[1];
            const up = row.find("a.button.js-sortableUp");
            up.attr("aria-label", `Move ${dataCell.textContent} Up`);
            const down = row.find("a.button.js-sortableDown");
            down.attr("aria-label", `Move ${dataCell.textContent} Down`);
        }
    });
}
